// extracted by mini-css-extract-plugin
export var redoItem = "_o8-1";
export var redoTrigger = "_o8-0";